import React from 'react';
import { useClipShare } from '../hooks/useClipShare';
import { Header } from './Header';
import { MainMenu } from './MainMenu';
import { SessionSetup } from './SessionSetup';
import { ChatRoom } from './ChatRoom';
import { AlertContainer } from './AlertContainer';
import { ContextMenu } from './ContextMenu';

export const MainLayout: React.FC = () => {
  const { currentView } = useClipShare();

  return (
    <div className="container">
      <Header />
      <AlertContainer />
      
      {currentView === 'main' && <MainMenu />}
      {currentView === 'setup' && <SessionSetup />}
      {currentView === 'chat' && <ChatRoom />}
      
      <ContextMenu />
    </div>
  );
};